export default __webpack_public_path__ + "static/media/icon-copy.8402c426.svg";